import { getCsrfCookie, isUserLoggedIn, isUserProf } from './Utils';
import axios                                         from 'axios';

class Surveys
{
    constructor ( surveyContainer )
    {

        this.answerSurveysLocalStorageName = 'as-surveys-answered';

        this.surveyContainer = surveyContainer;

        this.surveyAnswerContainers = this.surveyContainer.querySelectorAll( '.survey-answer' );
        this.answers                = this.surveyContainer.querySelectorAll( 'input[type=radio]' );
        this.btnSubmit              = this.surveyContainer.querySelector( '.btn-survey-submit' )

        this.surveyId = this.surveyContainer.querySelector( '[name="survey-id"]' )?.value ?? false;

        if ( !this.surveyId )
        {
            return;
        }

        this.surveyId = parseInt( this.surveyId );

        /*if ( isUserProf() )
        {
            this.bindMustLoginEvents( "profs" )
        } else */if ( isUserLoggedIn() )
        {

            this.maybeGetSetExistingAnswer();


        } else
        {


            this.bindMustLoginEvents( "jeunes" )
        }
    }


    bindEvents ()
    {
        Array.from( this.answers )
            .forEach( el => el.addEventListener( 'click', this.adjustSubmitButton.bind( this ) ) );

        this.surveyContainer.addEventListener( 'submit', this.submit.bind( this ) );
    }

    bindMustLoginEvents ( audience = "jeunes" )
    {

        if ( "jeunes" === audience )
        {
            Array.from( this.answers )
                .forEach( el => el.addEventListener( 'click', this.promptLogin.bind( this ) ) );

            this.surveyContainer.addEventListener( 'submit', this.promptLogin.bind( this ) );

        } else if ( "profs" === audience )
        {
            Array.from( this.answers )
                .forEach( el => el.addEventListener( 'click', this.promptLoginProfs.bind( this ) ) );

            this.surveyContainer.addEventListener( 'submit', this.promptLoginProfs.bind( this ) );
        }
    }


    promptLogin ( event )
    {
        event.preventDefault();

        const triggerEvent = new Event( 'openExplanationJeunes' );
        window.dispatchEvent( triggerEvent );


    }

    promptLoginProfs ( event )
    {
        event.preventDefault();

        const triggerEvent = new Event( 'openExplanationProfs' );
        window.dispatchEvent( triggerEvent );


    }


    adjustSubmitButton ( event )
    {

        const chosenAnswer = this.getChosenAnswer()

        this.btnSubmit.disabled = !chosenAnswer;
    }

    getChosenAnswer ()
    {

        const answer = Array.from( this.answers ).filter( e =>
        {
            return e.checked;
        } );

        if ( answer[ 0 ] )
        {
            return parseInt( answer[ 0 ]?.value ) ?? false;
        }

        return false;
    }

    async submit ( event )
    {
        event.preventDefault();

        const answer = this.getChosenAnswer();

        this.saveAnswerLocal( answer );

        const submittedAjax = await this.saveAnswerServer( answer );

        this.setAnswerAndDisabled( answer );
    }


    maybeGetSetExistingAnswer ()
    {

        let answeredSurveys = window.localStorage.getItem( this.answerSurveysLocalStorageName );

        if ( !answeredSurveys )
        {
            this.bindEvents();
            return;
        }


        answeredSurveys = JSON.parse( answeredSurveys );


        let existingSurvey = answeredSurveys.filter( as => as.surveyId === this.surveyId );

        if ( existingSurvey.length < 1 )
        {
            this.bindEvents();
            return;
        }


        existingSurvey = existingSurvey[ 0 ];

        this.setAnswerAndDisabled( existingSurvey.answer );

    }


    setAnswerAndDisabled ( answer )
    {

        let answeredAnswer = Array.from( this.answers ).filter( ans => parseInt( ans.value ) === parseInt( answer ) );

        if ( answeredAnswer )
        {

            answeredAnswer = answeredAnswer[ 0 ];


            answeredAnswer.checked  = true;
            this.btnSubmit.disabled = true;

            answeredAnswer.closest( '.survey-answer' ).querySelector( '.disabled-replacement' ).classList.add( 'chosen' );

            this.surveyContainer.classList.add( 'already-answered' );
        }
    }

    saveAnswerLocal ( answer )
    {
        let answeredSurveys = window.localStorage.getItem( this.answerSurveysLocalStorageName );

        if ( answeredSurveys )
        {
            answeredSurveys = JSON.parse( answeredSurveys );
        } else
        {
            answeredSurveys = [];
        }

        answeredSurveys.push( {
            surveyId : this.surveyId,
            answer   : answer,
        } );

        window.localStorage.setItem( this.answerSurveysLocalStorageName, JSON.stringify( answeredSurveys ) );


    }

    async saveAnswerServer ( answer )
    {

        this.surveyContainer.classList.add( 'ajaxing' );

        try
        {

            const csrfCookie = await getCsrfCookie();

            const newAnswers = await axios.post( '/endpoints/surveys',
                {
                    surveyId : this.surveyId,
                    answer,
                },
                {
                    withCredentials : true,
                    // headers         : {
                    //     'X-CSRF-TOKEN' : token,
                    // },
                } );



            this.adjustAnswers( newAnswers.data );
        }
        catch (error)
        {
            console.error( '[Surveys] saveAnswerServer:error ', error );
        }

        this.surveyContainer.classList.remove( 'ajaxing' );
    }


    adjustAnswers ( newResults )
    {

        Array.from( this.surveyAnswerContainers ).forEach( surveyAnserEl =>
        {

            const currId        = surveyAnserEl.dataset.answerId;
            const resultsAnswer = newResults[ currId ] ?? false;

            const backgroundChart   = surveyAnserEl.querySelector( '.background-chart' );
            const percentageValueEl = surveyAnserEl.querySelector( '.percentage-value' );


            if ( resultsAnswer )
            {
                backgroundChart.style.width = resultsAnswer.percentage + '%';
                percentageValueEl.innerHTML = Math.round( resultsAnswer.percentage ) + '%';
            } else
            {
                backgroundChart.style.width = '0%';
                percentageValueEl.innerHTML = '0%';
            }


        } )
    }
}


document.addEventListener( 'DOMContentLoaded', () =>
{
    const surveys = document.querySelectorAll( '.weekly-survey-container' );

    if ( surveys.length > 0 )
    {
        Array.from( surveys )
            .forEach( s => new Surveys( s ) );
    }

} );
